import { RegistrationAttendeeItem } from './registration-attendee-item.model';
import { RegistrationCustomRegFieldResponse } from './registration-custom-reg-field-response.model';
import { EventCustomRegField } from '../custom-reg-fields/event-custom-reg-field.model';

export class RegistrationAttendee {
  public AttendeeId: number;
  public RegistrationId: number;
  public Notes: string;
  public NameForBadge: string;
  public ProfileId: number;
  public DisplayName: string;
  public OrgName: string;
  public Prefix: string;
  public FName: string;
  public Mi: string;
  public LName: string;
  public Suffix: string;
  public Title: string;
  public Email: string;
  public Phone: string;
  public Ext: string;
  public Address1: string;
  public Address2: string;
  public City: string;
  public State: string;
  public Zip: string;
  public ZipExt: string;
  public OrgProfileId: number;
  public CommunicateWithProfileId: number;
  public IsMember: boolean;
  public CustomFieldResponses: Array<RegistrationCustomRegFieldResponse>;
  public Custom1: string = '';
  public Custom2: string = '';
  public Custom3: string = '';
  public Custom4: string = '';
  public Custom5: string = '';
  public Attended: boolean;
  public AttendeeHeaderId: number;

  public Items: Array<RegistrationAttendeeItem> = [];

  public searchAllProfiles: boolean;
  public CreateProfile: boolean;
  public _showMiscFields: boolean = false;

  public constructor() {
    this.AttendeeId = 0;
    this.RegistrationId = 0;
    this.Notes = '';
    this.NameForBadge = '';
    this.ProfileId = 0;
    this.DisplayName = '';
    this.OrgName = '';
    this.Prefix = '';
    this.FName = '';
    this.Mi = '';
    this.LName = '';
    this.Suffix = '';
    this.Title = '';
    this.Email = '';
    this.Phone = '';
    this.Ext = '';
    this.Address1 = '';
    this.Address2 = '';
    this.City = '';
    this.State = '';
    this.Zip = '';
    this.ZipExt = '';
    this.OrgProfileId = 0;
    this.CommunicateWithProfileId = 0;
    this.IsMember = false;
    this.Attended = false;
    this.AttendeeHeaderId = 0;

    this.Items = new Array<RegistrationAttendeeItem>();
    this.CustomFieldResponses = new Array<RegistrationCustomRegFieldResponse>();

    this.searchAllProfiles = false;

    this.CreateProfile = false;
  }
}
